import { LAYOUT } from '../../../../../reactor/common';

export default (pageStyle = [], width = 0) => {
  let props;
  const portrait = pageStyle.includes('portrait');

  if (LAYOUT.VIEWPORT.PORTRAIT) {
    if (portrait) {
      props = { height: parseInt(width * 1.66, 10) };
    }
  } else {
    props = {
      width: parseInt(width * 0.525, 10),
      height: parseInt(width * 0.34, 10),
    };
    if (portrait) props.height = parseInt(width * 0.75, 10);
    if (pageStyle.includes('square')) props.height = props.width;
  }

  return props;
};
